import axios from 'lib/axios';
import { UpdateIdealProfile } from '../Process/store';

export const fetchUpdateBetesaIdealProfile = async (betesaTestId: number, body: UpdateIdealProfile) => {
  const response = await axios.put(`/ideal_profile/betesa/update/${betesaTestId}`, body);
  return response
}